import { render } from "./TheatreDashboard.vue?vue&type=template&id=6527b621"
import script from "./TheatreDashboard.vue?vue&type=script&lang=js"
export * from "./TheatreDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__